package it.neckar.lizergy.comments.model

import it.neckar.editHistory.PositionEdit
import it.neckar.editHistory.PositionEditHistory
import it.neckar.lizergy.comments.lifecycle.HasLifeCycle
import it.neckar.lizergy.comments.lifecycle.LifeCycleState
import it.neckar.open.unit.si.ms
import it.neckar.user.UserLoginName
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable

@Serializable
data class Comment(
  val id: CommentId,
  val comment: PositionEditHistory<String>,
  override val lifeCycleState: LifeCycleState = LifeCycleState.Active,
) : HasLifeCycle {
  constructor(newComment: String, userLoginName: UserLoginName, editTime: @ms Double) : this(id = CommentId.random(), comment = PositionEditHistory(newEntry = newComment, loginName = userLoginName, editTime = editTime))

  val currentEdit: PositionEdit<String>
    get() = comment.currentEdit

  val hasBeenEdited: Boolean
    get() = comment.allEdits.size > 1

  @Serializable
  data class CommentId(val uuid: NativeUuid) {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): CommentId {
        return CommentId(randomUuid4())
      }
    }
  }
}
